<template>
  <div class="theme-card-wrapper" :class="{ shadow }" :id="id">
    <div class="card-header" v-if="!hideHeader">
      <div class="header-title-wrapper">
        <svg-icon :iconName="icon" :width="51" current-color v-if="icon" />
        <span class="marker" v-else></span>
        <span class="title" v-if="title">{{ title }}</span>
      </div>
      <slot name="extra"></slot>
    </div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
// import { isMobile, uuid } from '@star/utils';

type Props = {
  id?: string;
  title?: string;
  path?: string;
  icon?: string;
  hideHeader?: boolean;
  shadow?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  hideHeader: false,
  shadow: false,
});

onMounted(async () => {});
</script>

<style lang="less" scoped>
.lotteryP {
  font-size: 50px;
  color: rgb(176, 176, 176);
}
.theme-card-wrapper {
  padding: 45px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 40px;
  background-color: var(--theme-backgroud-color);

  &.shadow {
    box-shadow: 0 0 49px 0 #d8d8d8;
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 44px;

    .header-title-wrapper {
      display: flex;
      align-items: center;

      .svg-icon {
        color: var(--theme-primary-color);
        margin-right: 25px;
      }

      .marker {
        display: inline-block;
        width: 14px;
        height: 51px;
        border-radius: 21px;
        background-color: var(--theme-btn-primary-background);
        margin-right: 25px;
      }

      .title {
        font-size: 51px;
        font-weight: 600;
        color: var(--text-color-default);
        line-height: 1.2;
      }
    }
  }
}

@media screen and (max-width: 768px) {
}
</style>
